/* @ngInject */
const go = (
  $state,
  areaLocal,
  routes
) => {
  const self = {}

  self.new = () => {
    $state.go(routes.consult.area.new.path)
  }

  self.consult = (_id, _area) => {
    areaLocal.saveCurrentId(_id)
    $state.go(routes.consult.area.details.path)
  }

  self.edit = (_id) => {
    areaLocal.saveCurrentId(_id)
    $state.go(routes.consult.area.edit.path)
  }

  return self
}

export default go



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/services/go.service.js